<div class="container pb-4">
  <!--<div class="px-4 mt-2">
        <button class="btn-inverse py-1" (click)="goBack()">
            < Back</button>
    </div>-->
  <app-shared-action-bar [saveReady]="unsavedChanges" [undoReady]="unsavedChanges"
    [displayActionSectionBar]="showActionSectionBar" (localBack)="localBack()"
    [alternativeBackDestination]="backURL"></app-shared-action-bar>

  <div class="mt-20 pb-4 md:px-8 px-4 ">

    <h2 class="settings-header" [ngClass]="{'text-sm':!showIntro}">Create Feedback Campaign</h2>

  </div>

  <div class="flex justify-between h-full md:mx-4">
    @if(!showSummary){
    <div class="px-4 md:w-3/5">
      @if(showIntro){
      <div>
        <p class="">Send a feedback campaign inviting individuals outside the system to complete a feedback request. They will
          receive an email containing a secure link and access code, allowing them to complete the feedback request once,
          within the specified time limit.</p>
        <button class="btn-primary mt-4" (click)="switchToCampaignDetails()">Create Feedback Campaign</button>
      </div>
      }
      @if(showCampaignDetails){
      <div>
        <div class="flex justify-between">
          <h4>Feedback Campaign Details</h4>
          <p class="text-green-400 text-sm">Step 1 of 6</p>
        </div>

        <div class="p-2">
          <div class="mt-4">
            <label class="mb-2 mt-4">Feedback Campaign Name*</label>
            <input type="text" class="text-box " [(ngModel)]="campaignName" />
            <p class=" text-sm text-grey-900 mx-1 mt-1">Create an internal name for this feedback campaign.</p>
          </div>
          <div class="mt-4">
            <label class="mb-2">Send Date</label>

            <p-datepicker class="date-input mt-1 ml-2 w-full md:w-2/5" inputStyleClass="text-box" [(ngModel)]="selectedCalendarSendDate" (ngModelChange)="updateCurrentSendDate()"
              dateFormat="dd M yy" [showIcon]="false"></p-datepicker>
            @if(errorPastSendDate){ <p class="text-danger-base my-1 text-sm ">Send Date cannot be set in past.
            </p>}

            <p class=" text-sm text-grey-900 mx-1 mt-1">The recipients will be sent the emails on the date
              selected.</p>

          </div>
          <div class="mt-3">
            <label class="mb-2">Expiry Date</label>

            <p-datepicker class="date-input mt-1 ml-2 w-full md:w-2/5" inputStyleClass="text-box" [(ngModel)]="selectedCalendarDate" (ngModelChange)="updateCurrentDate()"
              dateFormat="dd M yy" [showIcon]="false"></p-datepicker>
            @if(errorExpiryBeforeSend){ <p class="text-danger-base my-1 text-sm">Expiry date
              cannot be before
              send date.</p>}

            <p class=" text-sm text-grey-900 mx-1 mt-1">Set the final date that the feedback request can be completed.
              After
              the expiry date the user will be informed the link has expired.</p>

          </div>
          <div>
            <div class="flex mt-3 items-center">
              <label class="mr-2">Anonymous feedback request</label>
              <app-toggle-switch [(checked)]="anonymousAudit"></app-toggle-switch>
            </div>
            <p class=" text-sm mt-3 text-grey-900 mx-1">An anonymous feedback request will stop the
              responses
              for
              the feedback request being tied back to
              an email when returned. The number of completed feedback requests will be available and reminders can
              be
              sent
              by
              the system to those who have not answered by the receipients will not be visible to any
              users of
              the
              system.</p>
          </div>


          <div class="flex justify-end  mt-4">

            <button class="btn-primary"
              [disabled]="campaignName.length == 0 || this.errorExpiryBeforeSend || this.errorPastSendDate"
              (click)="confirmCampaignDetails()">Next</button>
          </div>
        </div>


      </div>
      }

      @if(showAuditDetails){
      <div>
        <div class="flex justify-between">
          <h4 class="mb-2">Feedback Request Details</h4>
          <p class="text-green-400 text-sm">Step 2 of 6</p>
        </div>

        <div class="p-2">
          <div>
            <label>Select Feedback Request</label>
            <select class="text-box " [(ngModel)]="selectedAudit" (ngModelChange)="updateAuditSelection()">
              @for(a of audits; track a){
              <option [ngValue]="a" [disabled]="a.AuditID == -1">
                {{a.AuditName}}
              </option>
              }

            </select>
            <p class=" text-sm text-grey-900 mt-1 mx-1">Select the feedback request to be completed by the
              recipients.
              Only feedback requests that have been enabled for
              external use will be displayed
              here.</p>
            @if(signatureWarning || repeatWarning){
            <div class="my-2 border-warning-base border-2 rounded-lg p-2 md:p-3 flex flex-col justify-between items-center">
              @if(signatureWarning){
              <div class="flex justify-between">
                <span class="material-symbols-outlined text-4xl text-warning-strong">
                  exclamation
                </span>
                <p class="text-sm">The selected feedback request includes a signature question, which will be omitted
                  as signatures are <strong>not</strong> supported in feedback campaigns.</p>
              </div>

              }
              @if(repeatWarning){

                <div class="flex justify-between" [class.mt-3]="signatureWarning">
                   <span class="material-symbols-outlined text-4xl text-warning-strong">
                  exclamation
                </span>
                      <p class="text-sm">The selected feedback request includes a repeated section, the repeated section will only appear
                once to the participant.</p>
                </div>
          
              }
            </div>

            }


          </div>
          <div class="mt-4">
            <label class="mb-2 mt-4">Public Name</label>
            <input type="text" class="text-box " [(ngModel)]="customName" />
            <p class=" text-sm text-grey-900 mx-1 mt-1">Create a public name for the feedback request. If none is
              entered, its existing name will be displayed to recipients.</p>
          </div>


          <div class="flex justify-between  mt-4">
            <button class="btn-inverse" (click)="returnToCampaignDetails()">Back</button>
            <button class="btn-primary" [disabled]="selectedAudit.AuditID==-1"
              (click)="confirmAuditNaming()">Next</button>
          </div>

        </div>

      </div>
      }

      @if(showLocations){
      <div>
        <div class="flex justify-between">
          <h4 class="mb-2">Location Selection</h4>
          <p class="text-green-400 text-sm">Step 3 of 6</p>
        </div>

        <div class="p-2">
          <div>
            <label>Select Location</label>
            <select class="text-box " [(ngModel)]="selectedLocation" (ngModelChange)="updateAuditSelection()">
              @for(l of locations; track l){
              <option [ngValue]="l" [disabled]="l.LocationID == -1">
                {{l.LocationName}}
              </option>
              }

            </select>
            <p class=" text-sm text-grey-900 mt-1 mx-1">Select the location that the feedback campaign relates to,
              the system uses the location for permissions to access feedback responses.</p>
          </div>

          <div class="flex justify-between  mt-4">
            <button class="btn-inverse" (click)="returnToAuditDetails()">Back</button>
            <button class="btn-primary" [disabled]="selectedLocation.LocationID==-1"
              (click)="confirmLocation()">Next</button>
          </div>

        </div>

      </div>
      }
      @if(showCampaignTypeSelect){
      <div>
        <div class="flex justify-between">
          <h4 class="mb-2">Gathering Responses</h4>
          <p class="text-green-400 text-sm">Step 4 of 6</p>
        </div>
        <div class="p-2 border-grey-500 border-2 rounded-lg">
          <p class="font-semibold text-green-700">Send By Email</p>
          <div class="flex justify-between  items-center">
            <div class="mr-4">

              <p class="mt-1 text-sm">Email feedback requests to specific people. Each person gets their
                own link, so
                you&#39;ll know
                who&#39;s
                replied and only one response is counted per person. Ideal when you want more
                controlled,
                personal feedback.</p>
            </div>


            <button (click)="confirmCampaignType(false,false)" class="btn-primary">Select</button>
          </div>

        </div>
        <div class="p-2 border-grey-500 border-2 rounded-lg mt-2">

          <p class="font-semibold text-green-700">Share a Link</p>
          <div class="flex justify-between items-center">
            <div class="mr-4">

              <p class="mt-1 text-sm">Create one link anyone can use to give feedback. You can share it in
                a
                newsletter, on a
                noticeboard, or open it on a tablet for visitors. Perfect for quick, open feedback from
                anyone
                connected to the service.</p>
            </div>

            <button (click)="confirmCampaignType(true,true)" class="btn-primary ">Select</button>

          </div>

        </div>
        <div class="p-2 border-grey-500 border-2 rounded-lg mt-2">
          <p class="font-semibold text-green-700">Email and Link Together</p>
          <div class="flex justify-between items-center">

            <div class="mr-4">

              <p class="mt-1 text-sm">Use both methods to reach more people. Send emails to key contacts
                and share
                a
                general link
                for
                everyone else. A flexible way to collect the widest range of feedback.</p>

            </div>
            <button (click)="confirmCampaignType(true,false)" class="btn-primary">Select</button>
          </div>

        </div>
        <button class="btn-inverse my-3" (click)="returnToLocationDetails()">Back</button>
      </div>
      }
      @if(showEmails){ <div>
        <div class="flex justify-between">
          <h4 class="mb-2">Recipients</h4>
          <p class="text-green-400 text-sm">Step 5 of 6</p>
        </div>


        <div class="flex flex-col">
          <input class="text-box" type="text" placeholder="Name" [(ngModel)]="currentRName" />
          <input class="text-box mt-2" type="text" placeholder="Reference" [(ngModel)]="currentRRef" />
          <input class="text-box mt-2" type="text" (keyup)="resetEmailValidation()" placeholder="Email"
            [(ngModel)]="currentREmail" />
          @if(errorEmail){
          <p class="text-danger-base ml-2">Invalid email format, please update.</p>
          }


          <button class="btn-inverse  mt-2 w-2/5" (click)="addReceipient()">Add Recipient</button>
          <p class="mt-1 text-sm text-grey-900">Enter the details of the receipients below, ensure that
            you
            have permission to contact
            the people entered. </p>
        </div>


        <table class="mt-6 w-full  table-auto bg-standardwhite border border-grey-900 p-2 hidden md:inline-table">
          <tr class="border-b border-green-700">
            <th class="text-left pl-1">Name</th>
            <th class="text-left">Reference</th>
            <th class="text-left">Email Address</th>
            <th>Remove</th>
          </tr>
          <tr>
            @if(recipients.length==0){<td colspan="4" class="text-grey-900 text-center">Please add
              recepients</td>}

          </tr>
          @for(r of recipients;track r){
          <tr class="border-b border-green-700">
            <td [ngClass]="{'text-left pl-1':r.Name}">{{r.Name}}
              @if(r.Name.length == 0){ <span>-</span>}
            </td>
            <td [ngClass]="{'text-left':r.Reference.length == 0}">{{r.Reference}}
              @if(r.Reference.length == 0){<span>-</span>}
            </td>
            <td>{{r.Email}}</td>
            <td class="text-center hover:cursor-pointer flex items-center justify-center" (click)="removeReceipient(r.GUID)"><span
                class="text-center material-symbols-outlined text-danger-base self-center my-auto">close</span>
            </td>
          </tr>
          }
        </table>

        <div class="flex flex-col mt-2">
          <div class="flex items-center mt-2">
            <label class="mr-2">I confirm the recipients are correct and adhere to regulations</label>
            <app-simple-toggle [(isChecked)]="selectedGDPR"></app-simple-toggle>
          </div>
          <div>
            <p class="text-sm "><span class="underline hover:cursor-pointer text-sm"
                (click)="switchFullConsentView()">click
                here
              </span> for full terms</p>
          </div>

        </div>
        @if(displayFullConsentDetails){
        <div class="mt-2">
          <p class="font-bold">Consent Confirmation</p>
          <p class="italic text-sm mt-1">By proceeding, you confirm that all recipients of the request
            have
            provided their clear and informed consent to be contacted for the purpose of completing
            this
            request. You agree that this consent has been obtained in compliance with all applicable
            data protection and privacy regulations, including (but not limited to) the UK GDPR and
            PECR
            (UK), the Data Protection Act 2018 and ePrivacy Regulations (Ireland), and relevant U.S.
            laws such as the CAN-SPAM Act and applicable state-level privacy laws (e.g., CCPA where
            applicable). </p>
          <p class="font-bold">Care Audits reserves the right to monitor usage and suspend access to this
            service in cases of misuse or non-compliance.</p>
        </div>
        }

        <div class="flex justify-between mt-4">
          <button class="btn-inverse" (click)="returnToTypeSelect()">Back</button>
          <button class="btn-primary" (click)="validateEmails()"
            [disabled]="!selectedGDPR || recipients.length == 0 || loadingValidation">
            @if(!loadingValidation){
            <span>Next</span>
            }
            @if(loadingValidation){
            <span>Loading...</span>
            }
          </button>
        </div>
        <div class="md:hidden mt-4">
          @for(r of recipients;track r){
          <div class=" my-1 flex">
            <div class=" rounded-l-md border-grey-500 p-1 border-[1px] flex-grow">
              <p class="fond-bold">{{r.Email}}</p>

              <p>Name: {{r.Name}}
                @if(r.Name.length==0){<span>-</span>}
              </p>
              <p>Ref: {{r.Reference}}
                @if(r.Reference.length==0){
                <span>-</span>
                }
              </p>
            </div>
            <div (click)="removeReceipient(r.GUID)"
              class="flex items-center rounded-r-md border-grey-500 p-1 border-[1px]">
              <span
                class="text-center material-symbols-outlined text-danger-base self-center my-auto ml-1 text-xl">close</span>
            </div>
          </div>
          }

        </div>
      </div>}

    </div>
    }

    @if(!showSummary){
    <div class=" border-l-2 border-l-grey-300 hidden md:block">

    </div>
    }

    @if(pbGeneral){
    <div class="md:flex flex-col flex-grow pl-2 hidden pr-4">
      @if(pbCampaign){
      <div class="py-1 px-2 border-[1px] mt-1 border-grey-300 rounded-md ">
        <p class="font-bold">{{campaignName}}</p>
        <p class="text-sm">{{formattedSendDate}} - {{formattedDate}}</p>
        <p class="text-sm">{{anonymousFormatted}}</p>
      </div>
      }
      @if(pbAudit){
      <div class="py-1 px-2 border-[1px] w-full border-grey-300 items-center rounded-md mt-1">
        <p class="text-sm text-green-400">Feedback Request <span class="text-offblack text-sm">{{auditName}}</span></p>
      </div>
      }
      @if(pbLocation){
      <div class="py-1 px-2 border-[1px] w-full border-grey-300 items-center rounded-md mt-1">
        <p class="text-sm text-green-400">Location <span
            class="text-offblack text-sm">{{selectedLocation.LocationName}}</span></p>
      </div>
      }
      @if(createLink){
      <div class="py-1 px-2 border-[1px] w-full border-grey-300 items-center rounded-md mt-1">
        <p class="text-sm text-green-400 font-bold">Reusable-Link Feedback Campaign</p>
      </div>
      }
      @if(pbEmails){
      <div class="py-1 px-2 border-[1px]  mt-1 border-grey-300 rounded-md">
        <p class="text-sm">{{recipients.length}} Receipients</p>
      </div>
      }
    </div>
    }
    @if(showSummary){
    <div class="md:w-3/5 w-full px-4">
      <div class="flex justify-between">
        <h4 class="mb-2">Feedback Campaign Overview</h4>
        <p class="text-green-400 text-sm">Step 6 of 6</p>
      </div>
      <div class="mt-3 md:px-3 md:border-grey-300 md:border-2 md:rounded-lg">
        <div class="mt-2 flex flex-col md:flex-row justify-between md:border-b-grey-300 md:border-b-2">
          <div class=" md:pl-2  pb-2 flex-grow">
            <p class="text-sm text-green-300">Feedback Campaign Name</p>
            <p class="text-lg ">{{campaignName}}</p>
          </div>
          <div class="hidden md:block md:border-l-2 md:border-l-grey-300"></div>
          <div class="mt-2 md:mt-0 md:px-2 pb-2 ">
            <p class="text-sm text-green-300">Duration</p>
            <p class="text-lg ">{{formattedSendDate}} - {{formattedDate}}</p>
          </div>
        </div>
        <div class="mt-2 flex flex-col md:flex-row justify-between md:border-b-grey-300 md:border-b-2 ">
          <div class="mt-2  pb-2 md:px-2">
            <p class="text-sm text-green-300">Feedback Campaign Type</p>
            <p class="text-lg ">{{anonymousFormatted}}</p>
          </div>
          <div class="hidden md:block md:border-l-2 md:border-l-grey-300 "></div>
          <div class="mt-2 md:0 md:px-2 flex flex-col flex-grow pb-2">
            <p class="text-sm text-green-300">Feedback Request</p>
            <div class="flex flex-col ">
              <p class="text-lg">{{customName}}</p>
              @if(customName!=selectedAudit.AuditName){
              <p class="text-grey-900">
                &#40;{{selectedAudit.AuditName}}&#41;</p>
              }
            </div>
          </div>
        </div>
        <div class="mt-2 flex flex-col md:flex-row justify-between ">
          <div class="mt-2 pb-2 md:px-2 flex-grow flex flex-col md:flex-row">
            <div class="flex-col flex mr-2">
              <p class="text-sm text-green-300">Location</p>
              <p>{{this.selectedLocation.LocationName}}</p>
            </div>
            <div class="hidden md:block md:border-l-2 md:border-l-grey-300 "></div>
            @if(!skipEmails){
            <div class="flex-col flex ml-2">

              <p class="text-sm text-green-300 ">Recipients</p>
              <div class="flex flex-col justify-between">

                <div class="flex items-center">
                  <p class="">{{validEmailCount()}} Recipients</p>
                  @if(invalidEmailCount()>0){
                  <p class="ml-1 text-sm text-danger-base">
                    &#40;{{invalidEmailCount()}} emails cannot be sent&#41;</p>
                  }

                </div>
                <p class="underline hover:cursor-pointer text-xs mt-1" (click)="displayFullValidatedEmailList()">View
                  Full List</p>
              </div>
            </div>
            }
            @if(skipEmails){
            <div>

            </div>
            }




          </div>
          <div class="hidden md:block md:border-l-2 md:border-l-grey-300"></div>
          <div class="mt-2 md:0 md:px-2 flex flex-col w-full md:w-2/5 pb-1 justify-center items-center">
            @if(validEmailCount() != 0 || skipEmails){
            <button (click)="sendFullRequest()"
              class="btn-primary w-full md:w-4/5 self-center my-3 text-xl p-3">Activate Feedback Campaign</button>
            }
            @if(validEmailCount() == 0 && !skipEmails){
            <p class="text-danger-base text-lg">No valid email
              addresses</p>
            }


          </div>
        </div>




      </div>

      @if(showSummaryEmailList){
      <div class="px-1 md:px-3 mt-3" ngClass="border-grey-300 border-2 rounded-md ">
        <table class="w-full table-auto bg-standardwhite px-2 hidden md:inline-table">
          <tr>
            <th class="text-left pl-1">Name</th>
            <th class="text-left">Reference</th>
            <th class="text-left">Email Address</th>
            <th class="text-center">Ready to Send</th>
          </tr>
          @for(r of validatedReturn.Request.Recipients; track r){
          <tr [ngClass]="{'text-grey-900':r.FailedCheck}">
            <td class="pl-1 text-left">{{r.Name}}</td>
            <td>{{r.Reference}}</td>
            <td>{{r.Email}}</td>
            <td class="text-center">
              @if(!r.FailedCheck){
              <span class="text-center material-symbols-outlined text-green-400 self-center my-auto">check_circle</span>
              }
              @if(r.FailedCheck){
              <span class="text-center material-symbols-outlined text-danger-base self-center my-auto">block</span>
              }
            </td>
          </tr>
          }

        </table>
        <div class="md:hidden">
          @for(r of validatedReturn.Request.Recipients; track r){
          <div class=" my-1 flex">
            <div class=" rounded-l-md border-grey-500 p-1 border-[1px] flex-grow">
              <p class="fond-bold">{{r.Email}}</p>
              <p>Name: {{r.Name}}
                @if(r.Name.length==0){
                <span>-</span>
                }
              </p>
              <p>Ref: {{r.Reference}}
                @if(r.Reference.length==0){
                <span>-</span>
                }
              </p>
            </div>
            <div class="flex items-center rounded-r-md border-grey-500 p-1 border-[1px]">
              <td class="text-center">
                @if(!r.FailedCheck){
                <span
                  class="text-center material-symbols-outlined text-green-400 self-center my-auto">check_circle</span>
                }
                @if(r.FailedCheck){
                <span class="text-center material-symbols-outlined text-danger-base self-center my-auto">block</span>
                }
              </td>
            </div>
          </div>
          }

        </div>

      </div>
      }

      <div class="w-full mt-3">
        <div class="border-green-300 border-2 rounded-lg">
          @if(!skipEmails){
          <div class=" p-3 text-sm flex justify-start items-center">
            <span class="material-symbols-outlined text-4xl text-green-400 mr-1">
              exclamation
            </span>
            <div>
              <p><strong>Activating a feedback campaign</strong> will trigger emails to be sent on the feedback campaign's
                start
                date.</p>
              <p>If the start date is set to today, emails will begin sending shortly.</p>
              <p>Larger lists will be sent over a longer period of time.</p>
            </div>
          </div>
          }
          @if(createLink){
          <div class=" p-3 text-sm flex justify-start items-center">
            <span class="material-symbols-outlined text-4xl text-green-400 mr-1">
              exclamation
            </span>
            <div>
              <p><strong>Feedback campaign link</strong> once the feedback campaign is made active the link to share will
                become available for use. It is also available from the feedback campaigns page.</p>
            </div>
          </div>
          }
        </div>
      </div>
      <div class="my-3">
        <button class="btn-inverse" (click)="returnEmailOrType()">Back</button>
      </div>
    </div>
    }
    <div class="">

    </div>

  </div>

</div>
